var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatalogos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3f47a845d6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148 155 L 710.25 155 L 710.25 168 L 148 168 Z M 148 155 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a9bdba3d9a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148 273 L 710.25 273 L 710.25 286 L 148 286 Z M 148 273 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f916196f47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148 391 L 710.25 391 L 710.25 405 L 148 405 Z M 148 391 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "180e53460b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148 509 L 710.25 509 L 710.25 523 L 148 523 Z M 148 509 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e956a5ccc5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148 628 L 710.25 628 L 710.25 641 L 148 641 Z M 148 628 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0ce11a59a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 621 L 108 621 L 108 647.546875 L 81 647.546875 Z M 81 621 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3f47a845d6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 154.984375 167.613281 L 704.007812 167.613281 C 707.449219 167.613281 710.25 164.808594 710.25 161.363281 C 710.25 157.917969 707.449219 155.113281 704.007812 155.113281 L 154.984375 155.113281 C 151.542969 155.113281 148.742188 157.917969 148.742188 161.363281 C 148.742188 164.808594 151.542969 167.613281 154.984375 167.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a9bdba3d9a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 704.007812 273.386719 L 154.984375 273.386719 C 151.542969 273.386719 148.742188 276.191406 148.742188 279.636719 C 148.742188 283.082031 151.542969 285.886719 154.984375 285.886719 L 704.007812 285.886719 C 707.449219 285.886719 710.25 283.082031 710.25 279.636719 C 710.25 276.191406 707.449219 273.386719 704.007812 273.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f916196f47)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 704.007812 391.707031 L 154.984375 391.707031 C 151.542969 391.707031 148.742188 394.464844 148.742188 397.910156 C 148.742188 401.402344 151.542969 404.160156 154.984375 404.160156 L 704.007812 404.160156 C 707.449219 404.160156 710.25 401.402344 710.25 397.910156 C 710.25 394.464844 707.449219 391.707031 704.007812 391.707031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#180e53460b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 704.007812 509.980469 L 154.984375 509.980469 C 151.542969 509.980469 148.742188 512.785156 148.742188 516.230469 C 148.742188 519.675781 151.542969 522.433594 154.984375 522.433594 L 704.007812 522.433594 C 707.449219 522.433594 710.25 519.675781 710.25 516.230469 C 710.25 512.785156 707.449219 509.980469 704.007812 509.980469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e956a5ccc5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 704.007812 628.253906 L 154.984375 628.253906 C 151.542969 628.253906 148.742188 631.058594 148.742188 634.503906 C 148.742188 637.949219 151.542969 640.753906 154.984375 640.753906 L 704.007812 640.753906 C 707.449219 640.753906 710.25 637.949219 710.25 634.503906 C 710.25 631.058594 707.449219 628.253906 704.007812 628.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 94.027344 148.320312 C 86.851562 148.320312 81 154.175781 81 161.363281 C 81 168.550781 86.851562 174.40625 94.027344 174.40625 C 101.203125 174.40625 107.003906 168.550781 107.003906 161.363281 C 107.003906 154.175781 101.203125 148.320312 94.027344 148.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 94.027344 266.59375 C 86.851562 266.59375 81 272.449219 81 279.636719 C 81 286.820312 86.851562 292.679688 94.027344 292.679688 C 101.203125 292.679688 107.003906 286.820312 107.003906 279.636719 C 107.003906 272.449219 101.203125 266.59375 94.027344 266.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 94.027344 384.914062 C 86.851562 384.914062 81 390.722656 81 397.910156 C 81 405.144531 86.851562 410.953125 94.027344 410.953125 C 101.203125 410.953125 107.003906 405.144531 107.003906 397.910156 C 107.003906 390.722656 101.203125 384.914062 94.027344 384.914062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 94.027344 503.1875 C 86.851562 503.1875 81 509.042969 81 516.230469 C 81 523.417969 86.851562 529.222656 94.027344 529.222656 C 101.203125 529.222656 107.003906 523.417969 107.003906 516.230469 C 107.003906 509.042969 101.203125 503.1875 94.027344 503.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ce11a59a5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 94.027344 621.460938 C 86.851562 621.460938 81 627.316406 81 634.503906 C 81 641.6875 86.851562 647.546875 94.027344 647.546875 C 101.203125 647.546875 107.003906 641.6875 107.003906 634.503906 C 107.003906 627.316406 101.203125 621.460938 94.027344 621.460938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogos);
export default __webpack_public_path__ + "static/media/catalogos.166fdcfdb3d1557ba1ffff823d97c2d8.svg";
export { ForwardRef as ReactComponent };